import { DatePipe } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@shared/components/icon/icon.component';
import { DISPLAY_TIME_FORMAT } from '@utilities/date-utilities.service';
import { IFindingCardData } from '../finding-card.interface';
import { formatFindingDuration } from '../finding-card.util';
import { FindingImageComponent } from '../finding-image/finding-image.component';

@Component({
  imports: [DatePipe, MatButtonModule, TranslateModule, IconComponent, FindingImageComponent],
  selector: 'app-finding-card',
  templateUrl: './finding-card.component.html',
})
export class FindingCardComponent {
  public readonly data = input.required<IFindingCardData>();
  public readonly selected = input<boolean>(false);
  public readonly dimmed = input<boolean>(false);
  public readonly canLoadImage = input<boolean>(false);
  public readonly imageCampaignExportId = input<string | null>(null);
  public readonly aspectRatio = input<string>('16 / 9');
  // The graph's finding color for the number badge; pink when not given.
  public readonly numberColor = input<string | null>(null);

  public readonly openOnPlatform = output<Event>();

  public readonly durationLabel = computed(() => formatFindingDuration(this.data().duration));

  public readonly displayTimeFormat = DISPLAY_TIME_FORMAT;
}
